export default function authenticityToken() {
  return $.param({ 'authenticity_token': $('[name="csrf-token"]')[0].content });
}
